import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { captureAttribution } from "@/lib/attribution";

// Capture marketing attribution BEFORE React renders, so every component
// (including the survey form's hidden fields) reads populated storage on first
// paint. Route changes after boot are handled by AttributionTracker.
captureAttribution(window.location.search);

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const container = document.getElementById("root");

// Prerendered builds ship full HTML in #root for crawlers/AI; on the client we
// re-render over it (framer-motion inline styles can't be hydrated 1:1, and a
// clean client render avoids hydration-mismatch errors while keeping the same
// visual output). The first HTML still carries every H1, meta and JSON-LD.
ReactDOM.createRoot(container).render(app);
